import './SellerDashboard.css';
import './DashboardGlobal.css';
import './Dashboard.css';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getSellerUnreadMessages,
  checkHasPaymentMethod,
  getWaitlist,
  offTheWaitlist,
  isVerified,
  resendEmailVerification
} from '../../utils/api';
import FadeIn from '../../utils/fadein';
import {
  getUserCompany,
  getCompanyPreferenceDepartment,
  getCompanyPreferenceSeniority,
  getCompanyPreferenceSize,
  getUserProfile,
  updateUser,
  getSellerDemosRescheduleCount,
  addUserEventTracking,
  getPackageItemsRemainingCount,
  getSiteNotification,
  getSellerWorkspace,
  publishCompany,
  toggleIsSeller
} from '../../utils/api';
import { getCurrentUser, refresh, isSeller } from '../../services/auth.service';
import { Link } from 'react-router-dom';
import close from '../../assets/design/dashboard/close.png';
import { FaClock, FaUser, FaEdit, FaListOl, FaCreditCard, FaRegEnvelopeOpen, FaUsers, FaRegCalendarAlt, FaRegEdit, FaRegCalendarCheck, FaVideo, FaYoutube, FaRegCalendarTimes, FaExclamationTriangle, FaRegCircle, FaQuestion, FaExclamationCircle, FaBuilding, FaCheck, FaAppleAlt, FaGooglePlay, FaHeadset, FaTimes, FaExclamation, FaCheckCircle, FaMagic, FaBars, FaRegUser, FaChartLine, FaRegQuestionCircle, FaSearchPlus, FaShapes } from "react-icons/fa";
import Spinner from '../../components/layout/Spinner';
import ScrollToTop from '../../components/layout/ScrollToTop';
import queryString from 'query-string';
import { Helmet } from 'react-helmet';
import SellerDemosAvailable from './SellerDemos_Available';
import SellerDemosUpcoming from './SellerDemos_Upcoming';
import SellerDemosIncomplete from './SellerDemos_Incomplete';
import SellerDemosCompleted from './SellerDemos_Completed';
import SellerDemosRescheduled from './SellerDemos_Rescheduled';
import SellerDemosCancelled from './SellerDemos_Cancelled';
import SellerDemosTeam from './SellerDemos_Team';
import SellerDemosExpired from './SellerDemos_Expired';
import SellerDemosInvite from './SellerDemos_Invite';
import Company2 from '../company/Company2';
import CompanyPreview from '../company/CompanyPreview';
import CompanyFeature from './CompanyFeature';
import {
  User,
  Calendar,
  RefreshCw,
  MessageSquare,
  CheckCircle,
  MoreVertical,
  Clock,
  AlertCircle,
  Search,
  Filter,
  ChevronDown,
  PlusCircle,
  PlayCircle,
  Settings
} from "lucide-react";

const SellerDashboardNew = () => {
  let user = getCurrentUser();
  const [demoStatus, setDemoStatus] = useState('team');
  const [incompleteDemosCount, setIncompleteDemosCount] = useState(0);
  const [upcomingDemosCount, setUpcomingDemosCount] = useState(0);
  const [availableDemosCount, setAvailableDemosCount] = useState(0);
  const [teamDemoCount, setTeamDemoCount] = useState(0);
  const [unreadMessages, setUnreadMessages] = useState([]);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [hasCompany, setHasCompany] = useState(false);
  const [companyLoaded, setCompanyLoaded] = useState(false);
  const [loadedProfile, setLoadedProfile] = useState(false);
  const [loadedWorkhours, setLoadedWorkhours] = useState(false);
  const [loadedQuestions, setLoadedQuestions] = useState(false);
  const [loadedIcp, setLoadedIcp] = useState(false);
  const [onboardingLoaded, setOnboardingLoaded] = useState(false);
  const [messagesLoaded, setMessagesLoaded] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(true);
  const [hasQuestions, setHasQuestions] = useState(false);
  const [hasWorkhours, setHasWorkhours] = useState(false);
  const [hasIcp, setHasIcp] = useState(false);
  const [hasProfile, setHasProfile] = useState(false);
  const [hasThumbnail, setHasThumbnail] = useState(false);
  const [hasCompanyLogo, setHasCompanyLogo] = useState(false);
  const [hasCompanyDescription, setHasCompanyDescription] = useState(false);
  const [company, setCompany] = useState({});
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const [paymentMethodLoaded, setPaymentMethodLoaded] = useState(false);
  const [hasPaymentMethod, setHasPaymentMethod] = useState(false);
  const [showWaitlist, setShowWaitlist] = useState(false);
  const [showWaitlistConfirm, setShowWaitlistConfirm] = useState(false);
  const [showEventBanner, setShowEventBanner] = useState(false);
  const [waitlist, setWaitlist] = useState([]);
  const [showUnread, setShowUnread] = useState(false);
  const [showRescheduleBanner, setShowRescheduleBanner] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [showPh, setShowPh] = useState(false);
  const [remainingCount, setRemainingCount] = useState(0);
  const [remainingCountLoaded, setRemainingCountLoaded] = useState(false);
  const [showRemaining, setShowRemaining] = useState(false);
  const [showWelcomeBanner, setShowWelcomeBanner] = useState(false);
  const [showVerificationError, setShowVerificationError] = useState(true);
  const [verificationSuccess, setVerificationSuccess] = useState(false);
  const [workspace, setWorkspace] = useState(null);
  const [isPublishing, setIsPublishing] = useState(false);
  const [publishComplete, setPublishComplete] = useState(false);
  const [showEnterName, setShowEnterName] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  const [showFeatures, setShowFeatures] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const [demoStatusEnabled, setDemoStatusEnabled] = useState(true);
  const [showFeedbackDialog, setShowFeedbackDialog] = useState(false);
  
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseimageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    if (isSeller() == false) {
      navigate('/manage-roles');
    }
    const parsed = queryString.parse(window.location.search);
    let tab = parsed['t'];

    if (tab && tab.length > 0)
      setDemoStatus(tab);
  }, []);

  async function checkSiteNotification() {
    let res = await getSiteNotification('seller_welcome');

    if (res.success) {
      if (res.data) {
        setShowWelcomeBanner(false);
      }

      else {
        setShowWelcomeBanner(true);
      }
    }
  }

  async function loadWorkspace() {
    let res = await getSellerWorkspace();

    if (res.success) {
      setWorkspace(res.data);

      if (res.data.needs_feedback != '0'){
        setShowFeedbackDialog(true);
      }
    }

    else if (res.status === 403) {
      await refresh();

      let res = await getSellerWorkspace();

      if (res.success) {
        setWorkspace(res.data);
      }
    }
  }

  async function loadRemainingCount() {
    let res = await getPackageItemsRemainingCount();

    if (res.success) {
      setRemainingCount(res.data);
      setRemainingCountLoaded(true);
    }
  }

  useEffect(async () => {
    async function checkIsVerified() {
      let res = await isVerified();

      if (res.success) {
        if (res.data === true) setShowVerificationError(false);
        else setShowVerificationError(true);
        setLoaded(true);
      }

      else if (res.status === 403) {
        await refresh();

        let res = await isVerified();

        if (res.success) {
          if (res.data === true) setShowVerificationError(false);
          else setShowVerificationError(true);
          setLoaded(true);
        }
      }
    }

    checkIsVerified();

    async function loadPaymentMethod() {
      let res = await checkHasPaymentMethod();

      if (res.success) {
        setHasPaymentMethod(res.data);
      }

      else if (res.status === 403) {
        await refresh();

        let res = await checkHasPaymentMethod();

        if (res.success) {
          setHasPaymentMethod(res.data);
        }
      }

      setPaymentMethodLoaded(true);
    }

    async function loadCompany() {
      let res = await getUserCompany();

      if (res.success) {
        setCompany(res.data);

        if (res.data.questions.length > 0) {
          setHasQuestions(true);
        }

      //  setShowWaitlist(res.data.on_waitlist);

        if (res.data.description === null || res.data.description === '') {
          setHasProfile(false);
        } else {
          setHasProfile(true);
        }

        if (parseInt(res.data.work_hours) > 0) {
          setHasWorkhours(true);
        } else {
          setHasWorkhours(false);
        }

        if (res.data.thumbnail_image && res.data.thumbnail_image.length > 0) {
          setHasThumbnail(true);
        }

        if (res.data.logo && res.data.logo.length > 0) {
          setHasCompanyLogo(true);
        }

        if (res.data.description && res.data.description.length > 0) {
          setHasCompanyDescription(true);
        }

        setDemoStatusEnabled(res.data.is_seller);

        setLoadedProfile(true);
        setLoadedQuestions(true);
        setLoadedWorkhours(true);
      } else if (res.status === 403) {
        await refresh();

        let res = await getUserCompany();

        if (res.success) {
          setCompany(res.data);

          if (res.data.questions.length > 0) {
            setHasQuestions(true);
          }

          if (res.data.description === '') {
            setHasProfile(false);
          } else {
            setHasProfile(true);
          }

          if (parseInt(res.data.work_hours) > 0) {
            setHasWorkhours(true);
          } else {
            setHasWorkhours(false);
          }

          if (res.data.thumbnail_image && res.data.thumbnail_image.length > 0) {
            setHasThumbnail(true);
          }

          if (res.data.logo && res.data.logo.length > 0) {
            setHasCompanyLogo(true);
          }

          if (res.data.description && res.data.description.length > 0) {
            setHasCompanyDescription(true);
          }

          setLoadedProfile(true);
          setLoadedQuestions(true);
          setLoadedWorkhours(true);
        }
      }

      else {
        setHasCompany(false);
        window.location = '/account/company';
      }

      setCompanyLoaded(true);
    }

    async function checkTimezone(timezone) {
      if (timezone == null || timezone == undefined || timezone == '') {
        let l_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        if (l_timezone) {
          let res = await updateUser({ timezone: l_timezone });

          if (res.status === 403) {
            await refresh();
            let res = await updateUser({ timezone: l_timezone });
          }
        }
      }
    }

    async function loadUserProfile() {
      let res = await getUserProfile();

      if (res.success) {
        setProfileLoaded(true);
        setUserProfile(res.data);
        await checkTimezone(res.data.tz);
        if (res.data.first_name === null) {
          setShowEnterName(true);
        }
      }

      else if (res.status === 403) {
        await refresh();
        let res = await getUserProfile();

        if (res.success) {
          setProfileLoaded(true);
          setUserProfile(res.data);
          await checkTimezone(res.data.tz);

          if (res.data.first_name === null) {
            setShowEnterName(true);
          }
        }
      }
    }

    async function checkIcp() {
      let res1 = await getCompanyPreferenceDepartment();
      let res2 = await getCompanyPreferenceSeniority();
      let res3 = await getCompanyPreferenceSize();

      if (
        res1.data.length === 0 &&
        res2.data.length === 0 &&
        res3.data.length === 0
      ) {
        setHasIcp(false);
      } else {
        setHasIcp(true);
      }

      setLoadedIcp(true);
    }

    async function checkRescheduleCount() {
      let res = await getSellerDemosRescheduleCount();

      if (res.success) {
        let count = parseInt(res.data);

        if (count > 0) {
          setShowRescheduleBanner(true);
          setShowRescheduleModal(true);
        }
      }

      else if (res.status === 403) {
        await refresh();

        let res = await getSellerDemosRescheduleCount();

        if (res.success) {
          let count = parseInt(res.data);

          if (count > 0) {
            setShowRescheduleBanner(true);
            setShowRescheduleModal(true);
          }
        }
      }
    }

    await loadCompany();
    await checkIcp();
    await loadUserProfile();
    await loadPaymentMethod();
    await checkRescheduleCount();
    await loadRemainingCount();
    await checkSiteNotification();
    await loadWorkspace();
  }, []);

  useEffect(() => {
    if (loadedProfile && loadedQuestions && loadedWorkhours && loadedIcp && paymentMethodLoaded) {
      if (
        hasProfile === false ||
        hasQuestions === false ||
        hasWorkhours === false ||
        hasIcp === false
      ) {
        setShowOnboarding(true);
      } else {
        setShowOnboarding(false);
      }

      setOnboardingLoaded(true);
    }
  }, [loadedProfile, loadedQuestions, loadedWorkhours, loadedIcp, paymentMethodLoaded]);

  useEffect(() => {
    // waitlist
    async function loadWaitlist() {
      let res = await getWaitlist();

      if (res.success) {
        setWaitlist(res.data);
      }
    }

    loadWaitlist();
  }, [company]);

  useEffect(() => {
    async function loadUnreadMessages() {
      let res = await getSellerUnreadMessages();

      if (res.success) {
        if (res.data.length > 0) {
          setHasUnreadMessages(true);
          setUnreadMessages(res.data);
          setShowUnread(true);
        }

        setMessagesLoaded(true);
      }

      else if (res.status === 403) {
        await refresh();

        let res = await getSellerUnreadMessages();

        if (res.success) {
          if (res.data.length > 0) {
            setHasUnreadMessages(true);
            setUnreadMessages(res.data);
            setShowUnread(true);
          }

          setMessagesLoaded(true);
        }
      }

      else {
        setMessagesLoaded(true);
      }
    }

    loadUnreadMessages();
  }, []);

  useEffect(async () => {
    await loadRemainingCount();
  }, [upcomingDemosCount]);

  async function handleVerificationClick() {
    let _res = await resendEmailVerification();

    if (_res.success) {
      setVerificationSuccess(true);
    }
  }

  function setStatus(status) {
    setDemoStatus(status);
    replaceQueryParam('t', status);
  }

  function replaceQueryParam(param, newValue) {
    // Create a URL object from the current page URL
    const url = new URL(window.location.href);

    // Access the URL's query string parameters
    const params = url.searchParams;

    // Set (or replace) the parameter
    params.set(param, newValue);

    // Update the URL in the address bar without reloading the page
    window.history.replaceState({}, '', `${url.pathname}?${params}`);
  }

  async function handleWaitlistConfirm() {
    let res = await offTheWaitlist();

    if (res.success) {
      window.location = window.location;
    }
  }

  async function handleRemainingClick() {
    setShowRemaining(true);
  }

  async function handlePublish() {
    setIsPublishing(true);

    let res = await publishCompany();

    if (res.success) {
      setIsPublishing(false);
      setPublishComplete(true);
    }

    else if (res.status === 403) {
      await refresh();

      let res = await publishCompany();

      if (res.success) {
        setIsPublishing(false);
        setPublishComplete(true);
      }
    }
  }

  async function handleUpdateName() {
    if (firstName.length === 0) {
      alert("Please enter a valid name");
      return;
    }

    let res = await updateUser({ first_name: firstName, last_name: lastName });

    if (res.success) {
      setShowEnterName(false);
      window.location = window.location;
    }

    else if (res.status === 403) {
      await refresh();

      let res = await updateUser({ first_name: firstName, last_name: lastName });

      if (res.success) {
        setShowEnterName(false);
      }
    }
  }

  const handlePauseToggle = () => {
    setIsPaused(!isPaused);
    // TODO: Implement API call to update pause status
  };

  const handleDemoStatusToggle = async () => {
        let res = await toggleIsSeller(!demoStatusEnabled);
    if (res.success) {
    setDemoStatusEnabled(!demoStatusEnabled);
    }
    // TODO: Implement API call to update status
  };

  return (
    <div>
      <ScrollToTop />
      <Helmet>
        <title>LeadrPro - My Dashboard</title>
      </Helmet>

      {onboardingLoaded === false && (
        <Spinner />
      )}

      {onboardingLoaded && showOnboarding === false && (
        <>
          <div className=''>
            <div className='sellerdashboard__top-buttons flex justify-between items-center mb-4'>
            {/* available credits button */}
            {remainingCountLoaded && remainingCount > 0 && company.payment_type === 'pay_now' && (
              <span onClick={() => handleRemainingClick()} className='sellerdashboard__demos-remaining inline-flex items-center px-5 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'>
                <span className='ml-1'>Demo Credit{remainingCount === 1 ? '' : 's'} </span>

                <span className='inline-flex items-center justify-center w-5 h-5 ms-2 text-xs font-semibold text-blue-800 bg-blue-200 rounded-full'>{remainingCount}</span> </span>
            )}
            {/* available credits button end */}

            {/* no credits left button */}
            {remainingCountLoaded && remainingCount == 0 && company.payment_type === 'pay_now' && (
              <>
                <Link to={'/select-plan'} className=''><span> {remainingCount}</span> Credit{remainingCount === 1 ? '' : 's'} Remaining</Link>
              </>
            )}

            <div>
              <Settings className='h-6 w-6 text-gray-500 hover:text-gray-700 cursor-pointer' onClick={() => {
                setShowSettingsMenu(!showSettingsMenu);
              }} />

              {showSettingsMenu && (
                <div className='absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50 border border-gray-200'>
                  <div className='py-1'>
                    <div className='px-4 py-2 border-b border-gray-200'>
                      <div className='flex items-center justify-between'>
                        <span className='text-sm text-gray-700'>Demo Requests</span>
                        <button
                          onClick={handleDemoStatusToggle}
                          className={`relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
                            demoStatusEnabled ? 'bg-green-500' : 'bg-gray-200'
                          }`}
                          role="switch"
                          aria-checked={demoStatusEnabled}
                        >
                          <span
                            className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                              demoStatusEnabled ? 'translate-x-4' : 'translate-x-0'
                            }`}
                          />
                        </button>
                      </div>
                      <p className='text-xs text-gray-500 mt-1'>
                        {demoStatusEnabled ? 'Accepting demo requests' : 'Not accepting demo requests'}
                      </p>
                    </div>
                    <Link to='/account/profile' className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'>Profile</Link>
                    <Link to='/account/company' className='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'>Company</Link>
                    </div>
                  </div>
                  )}
            </div>


            {/* no credits left button end */}

            {/* pause demo requests button */}
            {/* {remainingCountLoaded && company.payment_type === 'pay_now' && (
              <button
                onClick={handlePauseToggle}
                className={`inline-flex items-center px-5 py-2 text-sm font-medium text-center rounded-lg transition-colors duration-200 ms-3 ${
                  isPaused 
                    ? 'bg-gray-100 text-gray-700 hover:bg-gray-200 focus:ring-gray-300'
                    : 'bg-green-100 text-green-700 hover:bg-green-200 focus:ring-green-300'
                }`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" />
                </svg>
                {isPaused ? 'Resume Requests' : 'Pause Requests'}
              </button>
            )} */}
            {/* pause demo requests button end */}
            </div>

            <div className='buyerdashboard__h1'>Manage Demos</div>
            <p className='text-md mb-2'>View and manage your demo requests.</p>
          </div>
        </>
      )}

      {showVerificationError && loaded === true && onboardingLoaded && showOnboarding === false && (
        <div className="mb-6 bg-gradient-to-r from-amber-50 to-amber-100 border-l-4 border-amber-500 rounded-lg shadow-sm">
          {verificationSuccess === false ? (
            <div className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-amber-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-sm text-amber-800 font-medium">
                      Verify your email address to unlock all features
                    </p>
                  </div>
                </div>
                <button
                  onClick={handleVerificationClick}
                  className="ml-4 inline-flex items-center px-3 py-1.5 border border-amber-300 text-xs font-medium rounded-full text-amber-700 bg-amber-100 hover:bg-amber-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-colors"
                >
                  Resend verification email
                </button>
              </div>
            </div>
          ) : (
            <div className="p-4">
              <p className="text-sm text-amber-800">
                Please check your inbox and follow instructions in verification email.
              </p>
            </div>
          )}
        </div>
      )}

      {loaded == true && companyLoaded == true && (hasThumbnail == true && hasCompanyDescription == true && hasCompanyLogo == true && hasWorkhours == true) && company.is_seller == false && company.company_id != 375 && (
        <div className=''>
          
          <div
            className="mb-8 relative overflow-hidden border-none p-0 shadow-2xl animate-fade-in"
            style={{ minHeight: 110 }}
            role="alert"
          >
            <div className="flex items-center gap-4 w-full bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 dark:from-purple-800 dark:via-purple-900 dark:to-purple-700 px-8 py-6 rounded-lg shadow-2xl relative">
              <div className="flex-shrink-0 flex items-center justify-center">

              </div>
              <div className="flex-1">
                <div className="text-2xl font-black text-white flex items-center gap-2 mb-2 drop-shadow">
                  <span className="">🚀 Your Account is Ready</span>
                </div>

                {publishComplete == false && (
                <div className="text-lg text-white/90 font-semibold mb-4 drop-shadow">
                  <span>Click "Go Live" below to start receiving demo requests.</span>
                </div>
                )}

                {isPublishing == false && publishComplete == true && (
                  <span className='font-extrabold text-base py-3 text-white'>
                    <span className="">Your company is now live. Users will now be able to request paid demos.</span>
                  </span>
                )}

                {isPublishing == false && publishComplete == false && (
                <button
                  className="button-gradient font-extrabold text-base px-8 py-3 rounded-xl shadow-xl animate-pulse flex items-center gap-2"
                  style={{
                    background: "linear-gradient(90deg,#D946EF 0%,#F97316 100%)",
                    color: "#fff",
                    boxShadow: "0 4px 32px 0 #D946EF33,0 2px 4px #F9731640"
                  }}
                  onClick={() => {
                    handlePublish();
                  }}
                  type="button"
                >
                  <span style={{ letterSpacing: 1.1 }}>Go Live <PlayCircle className="h-4 w-4 text-white" />
                   </span>
                </button>
                )}

                {isPublishing == true && (
                  <svg className="animate-spin h-5 w-5 text-white mr-3" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 1 1 16 0A8 8 0 0 1 4 12zm2.5-1h11a2.5 2.5 0 1 1-5 0h-6a2.5 2.5 0 0 1-5 0z"></path>
                  </svg>
                )}
              </div>
             
            </div>
          </div>
        </div>
      )}

{hasUnreadMessages && messagesLoaded && onboardingLoaded && (
          <div className="relative mb-6">
            <div className="flex items-center gap-4 bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 p-4 rounded-lg shadow-sm">
              <div className="flex-shrink-0">
                <div className="relative">
                  <MessageSquare className="h-6 w-6 text-blue-500" />
                  <span className="absolute -top-1 -right-1 flex h-3 w-3">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500"></span>
                  </span>
                </div>
              </div>
              <div className="flex-1 flex items-center justify-between">
                <p className="text-sm text-blue-700 font-medium">
                  You have unread messages in your inbox
                </p>
                <Link
                  to="/dashboard/inbox"
                  className="ml-4 inline-flex items-center px-3 py-1.5 border border-blue-300 text-xs font-medium rounded-full text-blue-700 bg-blue-50 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >
                  View messages
                </Link>
              </div>
            </div>
          </div>
        )}

        {showRescheduleBanner && loaded === true && onboardingLoaded && showOnboarding === false && (
          <div className="relative mb-6">
            <div className="flex items-center gap-4 bg-gradient-to-r from-amber-50 to-orange-50 border-l-4 border-orange-500 p-4 rounded-lg shadow-sm">
              <div className="flex-shrink-0">
                <div className="relative">
                  <Calendar className="h-6 w-6 text-orange-500" />
                  <span className="absolute -top-1 -right-1 flex h-3 w-3">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-orange-500"></span>
                  </span>
                </div>
              </div>
              <div className="flex-1 flex items-center justify-between">
                <p className="text-sm text-orange-700 font-medium">
                  Reschedule request pending
                </p>
                <button
                  onClick={() => {
                    setShowRescheduleModal(false);
                    setStatus('rescheduled');
                  }}
                  className="ml-4 inline-flex items-center px-3 py-1.5 border border-orange-300 text-xs font-medium rounded-full text-orange-700 bg-orange-50 hover:bg-orange-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors"
                >
                  Confirm new time
                </button>
              </div>
            </div>
          </div>
        )}
        
      <div className='dashboard__notifications'>
        {loaded == true && onboardingLoaded == true && showOnboarding == false && workspace && workspace.available_demos != '0' && (
          <>
            <div className='dashboard__notification-card' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => {
              setStatus('team')
            }}>
              <span className='dashboard__notification-card-count'>{workspace.available_demos}</span>

              <span style={{ marginLeft: '20px', borderLeft: 'solid 1px #ccc', paddingLeft: '20px' }}>
                {`New demo request${parseInt(workspace.available_demos) > 1 ? 's' : ''}`}
              </span>
            </div>
          </>
        )}

        {loaded == true && onboardingLoaded == true && showOnboarding == false && workspace && workspace.upcoming_demos != '0' && (
          <>
            <div className='dashboard__notification-card' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => {
              setStatus('upcoming')
            }}>
              <span className='dashboard__notification-card-count'>{workspace.upcoming_demos}</span>

              <span style={{ marginLeft: '20px', borderLeft: 'solid 1px #ccc', paddingLeft: '20px' }}>
                {`Scheduled demo${parseInt(workspace.upcoming_demos) > 1 ? 's' : ''}`}
              </span>
            </div>
          </>
        )}

        {loaded == true && onboardingLoaded && showOnboarding == false && workspace && workspace.needs_feedback != '0' && (
          <div className='dashboard__notification-card' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => {
            setStatus('incomplete')
          }}>
            <span className='dashboard__notification-card-count'>{workspace.needs_feedback}</span>

            <span style={{ marginLeft: '20px', borderLeft: 'solid 1px #ccc', paddingLeft: '20px' }}>
              {`Completed (Needs feedback)`}
            </span>
          </div>
        )}

        
      </div>

      <div className=''>
        {showOnboarding === false && showWaitlist === false && (
          <>
            {!userProfile.tz && (
              <h2 className='sellerdashboard__welcome'>
                <span className='buyerdashboard__timezone'>
                  <a href='/account/profile#timezone' className='link'>
                    Set your timezone
                  </a>
                </span>
              </h2>
            )}
          </>
        )}

        {showOnboarding === false && showWaitlist === false && (
          <div className='dashboard__demo-options-container'>

            <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'team'
                ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                : 'text-gray-600 hover:text-purple-600'
              }`}
              onClick={() => setStatus('team')}>
              <span className='dashboard__demo-option-icon'><FaRegUser /></span> <span>Pending Demos</span>

              {teamDemoCount > 0 && (
                <span className='dashboarddemo__flag-incomplete'></span>
              )}
            </div>


            <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'upcoming'
                ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                : 'text-gray-600 hover:text-purple-600'
              }`}
              onClick={() => setStatus('upcoming')}>
              <span className='dashboard__demo-option-icon'><FaRegCalendarAlt /></span> <span>Scheduled Demos</span>
              {workspace && workspace.upcoming_demos != '0' && (
                <span className='inline-flex items-center justify-center w-5 h-5 ms-2 text-xs font-semibold text-purple-800 bg-purple-200 rounded-full'>{workspace.upcoming_demos}</span>
              )}
            </div>

            <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'rescheduled'
                ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                : 'text-gray-600 hover:text-purple-600'
              }`}
              onClick={() => setStatus('rescheduled')}>
              <span className='dashboard__demo-option-icon'><FaRegCalendarTimes /></span> <span>Reschedules</span>
              {workspace && workspace.rescheduled_demos != '0' && (
                <span className='inline-flex items-center justify-center w-5 h-5 ms-2 text-xs font-semibold text-purple-800 bg-purple-200 rounded-full'>{workspace.rescheduled_demos}</span>
              )}
            </div>

            { loaded == true && onboardingLoaded && showOnboarding == false && workspace && workspace.needs_feedback != '0' && (
            <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'incomplete'
                ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                : 'text-gray-600 hover:text-purple-600'
              }`}
              onClick={() => setStatus('incomplete')}>
              <span className='dashboard__demo-option-icon'><FaRegEdit /></span> <span>Needs Feedback</span>
              <span className='inline-flex items-center justify-center w-5 h-5 ms-2 text-xs font-semibold text-purple-800 bg-purple-200 rounded-full'>{workspace.needs_feedback}</span>
            </div>
            )}

            <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'completed'
                ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                : 'text-gray-600 hover:text-purple-600'
              }`}
              onClick={() => setStatus('completed')}>
              <span className='dashboard__demo-option-icon'><FaRegCalendarCheck /></span> <span>Completed</span>
              {workspace && workspace.completed_demos != '0' && (
                <span className='inline-flex items-center justify-center w-5 h-5 ms-2 text-xs font-semibold text-purple-800 bg-purple-200 rounded-full'>{workspace.completed_demos}</span>
              )}
            </div>

             <div className={`flex items-center px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${demoStatus === 'canceled'
                ? 'bg-purple-50 text-purple-600 border-b-2 border-purple-600 border-solid'
                : 'text-gray-600 hover:text-purple-600'
              }`}
              onClick={() => setStatus('canceled')}>
              <span className='dashboard__demo-option-icon'><FaTimes /></span> <span>Cancelled/Declined</span>
            </div>

            {/* <div className={demoStatus === 'expired' ? 'dashboard__demo-option--active' : 'dashboard__demo-option'}
              onClick={() => setStatus('expired')}>
              <span className='dashboard__demo-option-icon'><FaRegCalendarTimes /></span> <span>Expired</span>
            </div> */}
          </div>
        )}

        {showOnboarding === false && showWaitlist === false && (
          <div className='sellerdashboard__seller-demos-container'>
            <div>
              {/* {demoStatus === 'available' && (
                <>
                  {(company.thumbnail_image == null || company.thumbnail_image.length === 0 || company.logo == null || company.logo.length === 0) && (
                    <FadeIn duration={300} delay={150} className='blurred'>
                      <SellerDemosInvite />
                    </FadeIn>
                  )}

                  {company.thumbnail_image && company.thumbnail_image.length > 0 && company.logo && company.logo.length > 0 && (
                    <FadeIn duration={300} delay={150}>
                      <SellerDemosInvite />
                    </FadeIn>
                  )}
                </>
              )} */}

              {demoStatus == 'canceled' && (
                <FadeIn duration={300} delay={150}>
                  <SellerDemosCancelled />
                </FadeIn>
              )}

              {demoStatus === 'upcoming' && (
                <FadeIn duration={300} delay={150}>
                  <SellerDemosUpcoming setUpcomingDemosCount={setUpcomingDemosCount} />
                </FadeIn>
              )}

              {demoStatus === 'pending' && (
                <FadeIn duration={300} delay={150}>
                  <SellerDemosAvailable refreshRemaining={loadRemainingCount} />
                </FadeIn>
              )}

              {demoStatus === 'team' && (
                <FadeIn duration={300} delay={150}>
                  <SellerDemosTeam />
                </FadeIn>
              )}

              {demoStatus === 'incomplete' && (
                <FadeIn duration={300} delay={150}>
                  <SellerDemosIncomplete setIncompleteDemosCount={setIncompleteDemosCount} />
                </FadeIn>
              )}

              {demoStatus === 'rescheduled' && (
                <FadeIn duration={300} delay={150}>
                  <SellerDemosRescheduled setIncompleteDemosCount={setIncompleteDemosCount} />
                </FadeIn>
              )}

              {demoStatus === 'completed' && (
                <FadeIn duration={300} delay={150}>
                  <SellerDemosCompleted />
                </FadeIn>
              )}
            </div>
          </div>
        )}
      </div>

      {showOnboarding && onboardingLoaded && showWaitlist === false && (
        <>
          <FadeIn delay={200} duration={200}>
            <div className='sellerdashboard__onboarding'>
              <h2>Finish your profile to access your Seller Dashboard</h2>

              <p className='sellerdashboard__onboarding-subtext'>
                This will help to ensure that we find you the best possible matches.
              </p>

              <div>
                <div className='sellerdashboard__onboarding-item'>
                  {hasProfile === false && (
                    <>
                      <div>
                        <div><FaEdit /> Complete your company profile <strong style={{ fontSize: 'small' }}>{`(1-2 minutes)`}</strong></div>
                        <div className='sellerdashboard__onboarding-description'>
                          Your company description, problem you solve and your
                          unique value propositions.
                        </div>
                      </div>

                      <span>
                        <Link
                          to='/account/company/edit'
                          className='sellerdashboard__onboarding-btn'>
                          Start
                        </Link>
                      </span>
                    </>
                  )}

                  {hasProfile && (
                    <>
                      <div>
                        <span><FaEdit /> Complete your company profile <strong style={{ fontSize: 'small' }}>{`(1-2 minutes)`}</strong></span>
                        <div className='sellerdashboard__onboarding-description'>
                          Your company description, problem you solve and your
                          unique value propositions.
                        </div>
                      </div>
                      <span className='sellerdashboard__onboarding-done'>
                        <Link to={'/account/company/edit'}>
                          Review
                        </Link>
                      </span>
                    </>
                  )}
                </div>

                {hasQuestions === false && (
                  <div className='sellerdashboard__onboarding-item'>
                    <div>
                      <div><FaListOl /> Setup your qualifier questions <strong style={{ fontSize: 'small' }}>{`(1-2 minutes)`}</strong></div>
                      <div className='sellerdashboard__onboarding-description'>
                        Fill out the qualification questions that prospects must
                        answer before applying to a meeting.
                      </div>
                    </div>
                    <span>
                      <Link
                        to='/account/qualifiers'
                        className='sellerdashboard__onboarding-btn'>
                        Start
                      </Link>
                    </span>
                  </div>
                )}

                {hasQuestions && (
                  <div className='sellerdashboard__onboarding-item'>
                    <div>
                      <div><FaListOl /> Setup your qualifier questions <strong style={{ fontSize: 'small' }}>{`(1-2 minutes)`}</strong></div>
                      <div className='sellerdashboard__onboarding-description'>
                        Fill out the qualification questions that prospects must
                        answer before applying to a meeting.
                      </div>
                    </div>
                    <span className='sellerdashboard__onboarding-done'>
                      <Link to={'/account/qualifiers'}>
                        Review
                      </Link>
                    </span>
                  </div>
                )}

                <div className='sellerdashboard__onboarding-item'>
                  {hasIcp === false && loadedIcp && (
                    <>
                      <div>
                        <div><FaUser /> Set your Ideal Customer Profile <strong style={{ fontSize: 'small' }}>{`(1-2 minutes)`}</strong></div>
                        <div className='sellerdashboard__onboarding-description'>
                          Select the criteria that we use to match candidates
                          for a demo.
                        </div>
                      </div>
                      <span>
                        <Link
                          to='/account/icp'
                          className='sellerdashboard__onboarding-btn'>
                          Start
                        </Link>
                      </span>
                    </>
                  )}

                  {hasIcp && loadedIcp && (
                    <>
                      <div>
                        <div><FaUser /> Set your Ideal Customer Profile <strong style={{ fontSize: 'small' }}>{`(1-2 minutes)`}</strong></div>

                        <div className='sellerdashboard__onboarding-description'>
                          Select the criteria that we use to match candidates
                          for a demo.
                        </div>
                      </div>
                      <span className='sellerdashboard__onboarding-done'>
                        <Link to={'/account/icp'}>
                          Review
                        </Link>
                      </span>
                    </>
                  )}
                </div>

                {hasWorkhours === false && (
                  <div className='sellerdashboard__onboarding-item'>
                    <div>
                      <div><FaClock /> Setup your weekly work hours <strong style={{ fontSize: 'small' }}>{`(1-2 minutes)`}</strong></div>
                      <div className='sellerdashboard__onboarding-description'>
                        Your available work hours during the week.
                      </div>
                    </div>
                    <span>
                      <a
                        href='/account/workhours'
                        className='sellerdashboard__onboarding-btn'>
                        Start
                      </a>
                    </span>
                  </div>
                )}

              </div>
            </div>
          </FadeIn>
        </>
      )}

      {/* {onboardingLoaded && showOnboarding === false && showWelcomeBanner == true && (
        <FadeIn delay={100} duration={300}>
          <div className='overlay'></div>
          <div className='modal sellerdashboard__welcome-modal'>
            <div className='modal__close' onClick={() => setShowWelcomeBanner(false)}>
              <FaTimes />
            </div>
            <h2 className='modal__h2'>
              Welcome to Your Seller Dashboard
            </h2>

            <div className='sellerdashboard__welcome-modal-body'>
              <div className='mb-10'>
                This is where you'll manage all of your scheduled demos as well as:
              </div>

              <div>
                <ul>
                  <li>Send/Reply to messages</li>
                  <li>View post-demo feedback upon completing a demo</li>
                  <li>Reassign or reschedule your assigned demos to your teammates</li>
                  <li>Manage your company's profile</li>
                  <li><Link to={`/company/${company.company_id}/company`} className='link'>View your company profile</Link></li>
                </ul>
              </div>

              <div className='sellerdashboard__welcome-quick-start-wrapper'>
                <p className='sellerdashboard__welcome-modal-header'>Checklist - Keep everything up to date</p>

                <div className='sellerdashboard__welcome-checklist'>
                  <div className='sellerdashboard__welcome-checklist-item' onClick={() => navigate('/account/company/edit')}>
                    <div className='sellerdashboard__welcome-quick-start-icon'>
                      {(company.logo == null || company.logo.length == 0) && (
                        <FaExclamationCircle />
                      )}

                      {(company.logo != null && company.logo.length > 0) && (
                        <div className='sellerdashboard__welcome-company-logo'>
                          <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' +
                            company.logo} />
                        </div>
                      )}
                    </div>

                    <div className='sellerdashboard__welcome-quick-start-name'>Company Logo
                      <div className='sellerdashboard__welcome-quick-start-time'>Upload</div>
                    </div>

                    {(company.logo == null || company.logo.length == 0) && (
                      <div className="sellerdashboard__welcome-checkmark-pending">
                        <FaExclamation />
                      </div>
                    )}

                    {(company.logo != null && company.logo.length > 0) && (
                      <div className="sellerdashboard__welcome-checkmark">
                        <FaCheck />
                      </div>
                    )}
                  </div>

                  <div className='sellerdashboard__welcome-checklist-item' onClick={() => navigate('/account/workhours')}>
                    <div className='sellerdashboard__welcome-quick-start-icon'><FaClock /></div>
                    <div className='sellerdashboard__welcome-quick-start-name'>Your Work Hours
                      <div className='sellerdashboard__welcome-quick-start-time'>Update</div>
                    </div>

                    {hasWorkhours && (
                      <div className='sellerdashboard__welcome-checkmark'>
                        <FaCheck />
                      </div>
                    )}
                  </div>

                  <div className='sellerdashboard__welcome-checklist-item' onClick={() => navigate('/account/qualifiers')}>
                    <div className='sellerdashboard__welcome-quick-start-icon'><FaRegQuestionCircle /></div>
                    <div className='sellerdashboard__welcome-quick-start-name'>Qualification Questions
                      <div className='sellerdashboard__welcome-quick-start-time'>Update</div>
                    </div>

                    {hasWorkhours && (
                      <div className='sellerdashboard__welcome-checkmark'>
                        <FaCheck />
                      </div>
                    )}
                  </div>

                  <div className='sellerdashboard__welcome-checklist-item' onClick={() => {
                    setShowFeatures(true);
                    setShowWelcomeBanner(false);
                  }
                  }>
                    <div className='sellerdashboard__welcome-quick-start-icon'><FaShapes /></div>
                    <div className='sellerdashboard__welcome-quick-start-name'>Company Features
                      <div className='sellerdashboard__welcome-quick-start-time'>Update</div>
                    </div>

                    <div className='sellerdashboard__welcome-checkmark'>
                      <FaCheck />
                    </div>

                  </div>
                </div>
              </div>

              <div className='sellerdashboard__welcome-quick-start-wrapper'>
                <p className='sellerdashboard__welcome-modal-header'>Useful links</p>

                <div className='sellerdashboard__welcome-quick-start'>
                  <a href="https://www.youtube.com/embed/jtYfrmvsGRs?si=fAj1gd39wzk6L0ob" target="_blank" className='sellerdashboard__welcome-quick-start-item'>
                    <div className='sellerdashboard__welcome-quick-start-icon'><FaYoutube /></div>
                    <div className='sellerdashboard__welcome-quick-start-name'>Product Overview
                      <div className='sellerdashboard__welcome-quick-start-time'>3:00 min</div>
                    </div>
                  </a>

                  <a href="https://play.google.com/store/apps/details?id=com.leadrpro.mobile" target="_blank" className='sellerdashboard__welcome-quick-start-item'>
                    <div className='sellerdashboard__welcome-quick-start-icon'><FaGooglePlay /></div>
                    <div className='sellerdashboard__welcome-quick-start-name'>Google Play Store
                      <div className='sellerdashboard__welcome-quick-start-time'>Download</div>
                    </div>
                  </a>

                  <a href="https://apps.apple.com/us/app/leadrpro/id6449265881" className='sellerdashboard__welcome-quick-start-item' target="_blank">
                    <div className='sellerdashboard__welcome-quick-start-icon'><FaAppleAlt /></div>
                    <div className='sellerdashboard__welcome-quick-start-name'>iOS Store
                      <div className='sellerdashboard__welcome-quick-start-time'>Download</div>
                    </div>
                  </a>

                  <Link to="/leave-feedback" className='sellerdashboard__welcome-quick-start-item'>
                    <div className='sellerdashboard__welcome-quick-start-icon'><FaHeadset /></div>
                    <div className='sellerdashboard__welcome-quick-start-name'>Support
                      <div className='sellerdashboard__welcome-quick-start-time'>Need assistance?</div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      )} */}

      {showRemaining && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowRemaining(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>Demo Credits Remaining</h2>
            <div>
              You have <span style={{ color: 'dodgerblue', fontWeight: 'bold' }}>{remainingCount}</span> demos remaining in your account.
            </div>

            <div style={{ marginTop: '15px' }}>
              Once out, you will still be able to receive and review requests from buyers. However you will need to purchase more credits to approve and schedule.
            </div>

            <div style={{ marginTop: '25px' }} className='center'>
              <Link to={'/select-plan'} className='text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800'>View Available Demo Packages</Link>
            </div>
          </div>
        </>
      )}

      {showFeatures && (
        <>
          <div className='overlay'></div>
          <div className='modal' style={{ width: '80%', marginLeft: '-40%' }}>
            <div className='modal__close' onClick={() => setShowFeatures(false)}>
              <FaTimes />
            </div>
            <h2 className='modal__h2'>Company Features</h2>

            <CompanyFeature />
          </div>
        </>
      )}

      {showEnterName && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowEnterName(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>Name is missing</h2>

            <p>
              <i>Please provide a valid name.</i>
            </p>

            <div>
              <div className='form-group'>
                <label><strong>First name</strong></label>
                <input type='text' placeholder='First name' value={firstName} onChange={(e) => setFirstName(e.target.value)} className='input' />
              </div>

              <div className='form-group'>
                <label><strong>Last name</strong></label>
                <input type='text' placeholder='Last name' value={lastName} onChange={(e) => setLastName(e.target.value)} className='input' />
              </div>

              <div className='form-group center'>
                <button className='btn' onClick={() => handleUpdateName()}>Update Profile</button>
              </div>
            </div>
          </div>
        </>
      )}

      {showWaitlistConfirm && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowWaitlistConfirm(false)}>
              <img src={close} />
            </div>
            <h2 className='modal__h2'>Get off the waitlist</h2>

            <p>
              By joining today you will get access to the following:
            </p>

            <ul style={{ marginTop: "20px" }}>
              <li>Your company public profile</li>
              <li>Instant exposure to 1000's of qualified leads</li>
              <li>Access to qualification answers before you book a demo</li>
            </ul>

            <div className='center' style={{ marginTop: "20px" }}>
              <button style={{ backgroundColor: "mediumaquamarine" }} className='btn btn--primary' onClick={() => handleWaitlistConfirm()}>Take me off the waitlist</button>
            </div>
          </div>
        </>
      )}

      {showPreview && (
        <>
          <div className='overlay'></div>
          <div className='modal dashboard__company-preview'>
            <div className='modal__close' onClick={() => setShowPreview(false)}>
              <FaTimes />
            </div>

            <div>
              <CompanyPreview id={company.company_id} />
            </div>
          </div>
        </>
      )}

      {showFeedbackDialog && (
      <>
        <div className='overlay'></div>
        <div className='modal animate-fade-in' style={{ maxWidth: '550px' }}>
          <div className='modal__close' onClick={() => setShowFeedbackDialog(false)}>
            <FaTimes />
          </div>
          <div className="p-2">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-purple-100 mb-4">
                <FaExclamationCircle className="text-purple-600 h-8 w-8" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Action Required: Demo Feedback</h2>
              <div className="h-1 w-24 bg-purple-600 mx-auto rounded-full"></div>
            </div>
            
            <div className="bg-purple-50 border-l-4 border-purple-600 p-4 rounded-lg mb-6">
              <p className="text-purple-900 font-medium text-lg mb-2">
                {workspace.needs_feedback} {parseInt(workspace.needs_feedback) === 1 ? 'demo needs' : 'demos need'} your attention
              </p>
              <p className="text-purple-700">
                Your feedback is crucial for improving match quality and helps us connect you with better-qualified leads.
              </p>
            </div>
            
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowFeedbackDialog(false)}
                className="px-6 py-2.5 text-purple-600 hover:text-purple-700 font-medium text-sm transition-colors"
              >
                Remind Me Later
              </button>
              <button
                onClick={() => {
                  setShowFeedbackDialog(false);
                  setStatus('incomplete');
                }}
                className="px-6 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors shadow-lg hover:shadow-xl font-medium text-sm flex items-center animate-pulse"
              >
                <span>Submit Feedback Now</span>
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </>
    )}
    </div>
  );
};

export default SellerDashboardNew;
